import styled, { css } from "styled-components";

import Props from "./props";

const Modal = styled.div<Props>`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99999;
    ${({ open }) =>
        !open &&
        css`
            pointer-events: none;
        `}
`;

export default Modal;
